const resizeAndMoveCoordinate = function (coordinates, factor = 1, origin = [0, 0]) {
  return [(coordinates[0] * factor) - origin[0], (coordinates[1] * factor) - origin[1]]
}

const resizeAndMoveLineStringCoordinates = function (lineStringCoordinates, factor = 1, origin = [0, 0]) {
  return lineStringCoordinates.map((coordinates) => {
    return resizeAndMoveCoordinate(coordinates, factor, origin)
  })
}

const resizeAndMovePolygonCoordinates = function (polygonCoordinates, factor = 1, origin = [0, 0]) {
  // un polygon est composé de plusieurs anneaux (1 exterieur et n interieur)
  return polygonCoordinates.map((ring) => {
    return ring.map((coordinates) => {
      return resizeAndMoveCoordinate(coordinates, factor, origin)
    })
  })
}

const resizeAndMoveMultiPointCoordinates = function (multiPointCoordinates, factor = 1, origin = [0, 0]) {
  return multiPointCoordinates.map((pointCoordinates) => {
    return resizeAndMoveCoordinate(pointCoordinates, factor, origin)
  })
}

const resizeAndMoveMultiLineStringCoordinates = function (multiLineStringCoordinates, factor = 1, origin = [0, 0]) {
  return multiLineStringCoordinates.map((LineStringCoordinates) => {
    return resizeAndMoveLineStringCoordinates(LineStringCoordinates, factor, origin)
  })
}
const resizeAndMoveMultiPolygonCoordinates = function (multiPolygonCoordinates, factor = 1, origin = [0, 0]) {
  return multiPolygonCoordinates.map((polygonCoordinates) => {
    return resizeAndMovePolygonCoordinates(polygonCoordinates, factor, origin)
  })
}

const resizeAndMoveFeatureGeometry = function (geometry, factor = 1, origin = [0, 0]) {
  switch (geometry.type) {
    case 'Point':
      geometry.coordinates = resizeAndMoveCoordinate(geometry.coordinates, factor, origin)
      break
    case 'Polygon':
      geometry.coordinates = resizeAndMovePolygonCoordinates(geometry.coordinates, factor, origin)
      break
    case 'LineString':
      geometry.coordinates = resizeAndMoveLineStringCoordinates(geometry.coordinates, factor, origin)
      break
    case 'MultiPoint':
      geometry.coordinates = resizeAndMoveMultiPointCoordinates(geometry.coordinates, factor, origin)
      break
    case 'MultiLineString':
      geometry.coordinates = resizeAndMoveMultiLineStringCoordinates(geometry.coordinates, factor, origin)
      break
    case 'MultiPolygon':
      geometry.coordinates = resizeAndMoveMultiPolygonCoordinates(geometry.coordinates, factor, origin)
      break
    case 'GeometryCollection':
      geometry.geometries = geometry.geometries.map((geometry) => {
        return resizeAndMoveFeatureGeometry(geometry, factor, origin)
      })
      break
  }

  return geometry
}

const resizeAndMoveFeature = function (feature, factor = 1, origin = [0, 0]) {
  feature.geometry = resizeAndMoveFeatureGeometry(feature.geometry, factor, origin)
  return feature
}

const resizeAndMoveFeatures = function (features, factor = 1, origin = [0, 0]) {
  return features.map((feature) => resizeAndMoveFeature(feature, factor, origin))
}

export default {
  resizeAndMoveFeature,
  resizeAndMoveFeatures,
}

export {
  resizeAndMoveFeature,
  resizeAndMoveFeatures
}
